import type { ConfiguracaoLoja } from '../api'

/** ROLE_ADMIN sempre cria; sem loja ativa (o suporte recebe as excluídas), qualquer um cria a primeira. */
export function podeCriarLoja(
  me: { roleAdmin: boolean } | undefined,
  lojas: Pick<ConfiguracaoLoja, 'ativo'>[] | undefined,
): boolean {
  if (me?.roleAdmin) return true
  return !(lojas ?? []).some((loja) => loja.ativo)
}

export function rotuloLoja(loja: Pick<ConfiguracaoLoja, 'nome' | 'ativo'>): string {
  return loja.ativo ? loja.nome : `${loja.nome} (excluída)`
}

function normalizarNomeLoja(nome: string): string {
  return nome.normalize('NFD').replace(/[^\p{L}\p{N}]/gu, '').toLowerCase()
}

/** Confirmação por nome ignorando acento, caixa, espaço e pontuação; nome vazio nunca confere. */
export function nomeConfere(digitado: string, nome: string): boolean {
  const alvo = normalizarNomeLoja(nome)
  return alvo !== '' && normalizarNomeLoja(digitado) === alvo
}

export interface EstadoLojaExcluida {
  lojaExcluida: { id: number; nome: string }
}

export function estadoLojaExcluida(loja: { id: number; nome: string }): EstadoLojaExcluida {
  return { lojaExcluida: { id: loja.id, nome: loja.nome } }
}

/** Lê o state de navegação deixado por quem acabou de excluir uma loja. */
export function lerLojaExcluida(estado: unknown): { id: number; nome: string } | null {
  const loja = (estado as Partial<EstadoLojaExcluida> | null | undefined)?.lojaExcluida
  if (!loja || typeof loja.id !== 'number' || typeof loja.nome !== 'string') return null
  return { id: loja.id, nome: loja.nome }
}
